import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { AdmPanelContainer } from "../../../../adm-panel/site/api/screens";
import { EngagementDataResponse, EngagementListPageControllerImpl, EngagementListPageFactoryImpl, ProductsStrings } from "../../../business";

export function EngagementListPage() {
    const { setCallbackLogin, handleLogout } = useAuth();
    const navigate = useNavigate();
    const strings = ProductsStrings['PTBR'].products.engagementListPage
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [isLoading, setLoading] = useState(true);
    const [engagementData, setEngagementData] = useState<EngagementDataResponse>()
    const controller = new EngagementListPageControllerImpl();
    const factory = new EngagementListPageFactoryImpl();

    const fetchData = async () => {
        try {
            const response = await controller.onLoad();
            setLoading(false);
            setEngagementData(response);
        } catch (error) {
            if (error === "401") {
                setCallbackLogin(
                    {
                        goBack: true,
                        origin: '/adm/engagement',
                    }
                );
                handleLogout();
                navigate('/auth');
            } else {
                console.error("Erro na requisição:", error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        window.addEventListener(
            "resize",
            () => {
                const ismobile = window.innerWidth < 992;
                if (ismobile !== isMobile) setIsMobile(ismobile);
            },
            false
        );
    }, [isMobile]);
    const content =
        <>
            <h4 className="mb-4">{strings.title}</h4>
            {isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(engagementData)}
        </>
    return <AdmPanelContainer children={content} />;
}
